import React, { useEffect, useState } from 'react';
import Modal from '../../../components/modal/modal';
import Input from '../../../components/input/input';
import Icon from '../../../components/icon/icon';
import { X } from '@phosphor-icons/react';
import '../style';
const PayoutModal = ({
  onSave,
  isOpen,
  onClose,
  payout,
  setHasUnsavedChanges,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const[formData, setFormData] = useState ({});
  const [confirmAccountNumber, setConfirmAccountNumber] = useState('');

  const toPascalCase = (str) => {
    return str
      .replace(/(^\w|[\s-]+\w)/g, match => match.toUpperCase())
      .replace(/[\s-]/g, ' ');

  };
  const handleChange = (e) =>{
    const {name, value } = e.target;
    const valueUpdate = name === 'account_holder_name' ? toPascalCase(value) : value;
    setFormData({
      ...formData,
      [name]: name === 'ifsc_code' ? valueUpdate.toUpperCase() : valueUpdate,
    });
    setHasUnsavedChanges(true);
  }
  
  useEffect(() => {
    if(payout){
      setFormData(payout);
      setIsEditMode(true);
    } else {
      setFormData({});
      setIsEditMode(false);
    }
  },[payout]);
  const validateForm = () => {
    const errors = {};
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (!formData.account_holder_name) errors.account_holder_name = 'Account holder name is required.';
    if (!formData.account_number) errors.account_number = 'Account number is required.';
    if (!formData.ifsc_code) {
      errors.ifsc_code = 'IFSC code is required.';
    } else if (!ifscRegex.test(formData.ifsc_code)) {
      errors.ifsc_code = 'Invalid IFSC code format.';
    }
    if (!formData.bank_name) errors.bank_name = 'Bank name is required.';
    if (formData?.account_number !== confirmAccountNumber) errors.equal = 'Account number should match';
    // if (!formData.branch_name) errors.branch_name = 'Branch name is required.';

    setErrors(errors);

    return Object.keys(errors).length === 0;
  }
  const handleSubmit = () =>{
    if(validateForm()){
      onSave(formData);
    }
  }
  return (
    <div>
      <Modal
        isOpen={isOpen}
        primaryText={isEditMode ? 'Submit':'Add'}
        secondaryText={ null }
        onClickPrimaryCta={handleSubmit}
        className={'payout-modal secondary-cta-hidden'}
        size="medium"
        title={
          <div className='flex justify-between w-full'>
            <div className='flex'>{isEditMode?'Edit Payout Details':'Add Payout details'}</div>
            <Icon type={'circle'} 
              onClick={onClose}
            >
              <X size={16} />
            </Icon> 
          </div>}
        onClose={onClose}
      >
        <div className='flex flex-col gap-8'>
          <Input
            name='account_holder_name'
            value={formData.account_holder_name}
            label="Account Holder Name"
            onChange={handleChange}
            validationStatus={errors.account_holder_name ? 'error' : null} 
            helpText={errors.account_holder_name}
            required
            width={420}
            maxLength={120}
          />
          <Input
            name='account_number'
            value={formData.account_number}
            label='Account Number'
            onChange={handleChange}
            validationStatus={errors.account_number ? 'error' : null} 
            helpText={errors.account_number}
            required
            width={420}
            maxLength={20}
          />
          <Input
            name='confirm_account_number'
            value={confirmAccountNumber}
            label="Confirm Account Number"
            onChange={(e) => setConfirmAccountNumber(e?.target?.value)}
            validationStatus={((confirmAccountNumber && formData.account_number) && (confirmAccountNumber !== formData.account_number)) || errors?.equal ? 'error' : null} 
            helpText={((confirmAccountNumber && formData.account_number) && (confirmAccountNumber !== formData.account_number)) || errors?.equal ? 'Account number should match' : ''}
            required
            width={420}
            maxLength={20}
          />
          <Input
            name='ifsc_code'
            value={formData.ifsc_code}
            label='IFSC Code'
            onChange={handleChange}
            validationStatus={errors.ifsc_code ? 'error' : null} 
            helpText={errors.ifsc_code}
            required
            width={420}
            maxLength={11}
          />
          <Input
            name='bank_name'
            value={formData.bank_name}
            label='Bank Name'
            onChange={handleChange}
            validationStatus={errors.bank_name ? 'error' : null} 
            helpText={errors.bank_name}
            required
            width={420}
            maxLength={300}
          />
        </div>
      </Modal>

    </div>
  )
}

export default PayoutModal